import { styled } from '@mui/material';
import Paper from '@mui/material/Paper';

const StyledPaper = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.primaryAlt,
  border: '1px solid',
  borderColor: theme.palette.border.secondary,
  borderTopColor: 'transparent',
  borderBottomLeftRadius: theme.shape.borderRadius * 5,
  borderBottomRightRadius: theme.shape.borderRadius * 5,
  padding: theme.spacing(2),
}));

export default StyledPaper;
